<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-audio-file`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.171 2a2 2 0 011.415.586l5.828 5.831A2 2 0 0142 9.831V44a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2h26.171zM32 6H10v36h28V12.038l-5 .001a1 1 0 01-1-1L31.999 6zm-9.075 8.867L32.17 16.9a.63.63 0 01.474.454l.017.1.337 3.384a.63.63 0 01-.668.691l-.092-.013-6.616-1.43a.252.252 0 00-.303.215l-.001.058 1.197 11.286c0 .07-.004.132-.012.186l-.002.018c0 2.845-2.35 5.151-5.25 5.151S16 34.694 16 31.849c0-2.846 2.35-5.152 5.25-5.152.713 0 1.392.14 2.012.391l-1.1-11.546a.632.632 0 01.579-.688h.09l.093.013z"/></svg>
</template>
<script>

export default {
  name: 'IconAudioFile',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
